import { render, staticRenderFns } from "./TermlyPolicy.vue?vue&type=template&id=29e47890&scoped=true"
import script from "./TermlyPolicy.vue?vue&type=script&lang=js"
export * from "./TermlyPolicy.vue?vue&type=script&lang=js"
import style0 from "./TermlyPolicy.vue?vue&type=style&index=0&id=29e47890&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29e47890",
  null
  
)

export default component.exports